import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import { GetAdminEmployeeActiveList, GetAdminPropertyReturnsList } from "../../Repository/Api";
import { imagepath } from "../../Repository/BaseUrl";
import { errorMsg, successMsg } from "../Toastify";
const AdminPropertyReport = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const navigate = useNavigate();
  const initialApplyState = {
    employee_ids: [],
    academic_year: [],
  };
  const [apply, setApply] = useState(initialApplyState);

  const [employee, setEmployee] = useState([]);
  const [savedReport, setSavedReport] = useState({});

  const FinancialYearOptions = () => {
    const date = new Date()
    const isApril = date.getMonth() >= 3
    const currentYear1 = date.getFullYear();
    const currentYear = currentYear1 + 1;
    const startYear = 2024;
    const numberOfYears = currentYear - 2024
    const dummyyearOptions = [];
    for (let i = 0; i < numberOfYears; i++) {
      dummyyearOptions.push(startYear + i);
    }
    const yearOptions = dummyyearOptions.map((item) => ({
      label: `${item}-${item + 1}`,
      value: `${item}-${item + 1}`
    }));

    const finalData = isApril ? yearOptions : yearOptions?.pop()
    // return finalData
    return yearOptions
  }

  const getEmployeeList = async () => {
    const response = await GetAdminEmployeeActiveList(token);
    if (response && response.statusCode === 200) {
      let employee = response?.data?.employee_details.map((label) => ({
        label: label.first_name + ' ' + label.last_name,
        value: label.id,
      }));
      // employee = [{ label: "All", value: "all" }, ...employee];
      setEmployee(employee);
    } else {
      errorMsg(response.message);
    }
  };
  useEffect(() => {
    getEmployeeList()
    getReport();
  }, []);
  const setData = (e, key) => {
    setApply({ ...apply, [key]: e });
    // if (validation[key]) setValidation({ ...validation, [key]: false });
  };
  const getReport = async () => {
    const response = await GetAdminPropertyReturnsList(apply?.academic_year, apply?.employee_ids?.value === undefined ? '' : apply?.employee_ids?.value, token);
    if (response && response.statusCode === 200) {
      setSavedReport(response?.data);
      successMsg(response?.data?.message)
    } else {
      errorMsg(response.message);
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle">Property Returns Report</h6>
                <div className="row align-items-end">
                  <div className="col-lg-4">
                    <label className="labeltext"> Employee Name *</label>
                    <ReactSelect
                      isMulti={false}
                      value={apply?.employee_ids}
                      onChange={(e) => {
                        setData(e, "employee_ids");
                      }}
                      options={
                        employee
                      }
                    />
                  </div>
                  <div className="col-lg-4">
                    <label className="labeltext"> Academic Year *</label>
                    <ReactSelect
                      isMulti={false}
                      value={{
                        label: apply.academic_year,
                        value: apply.academic_year,
                      }}
                      onChange={(selectedOption) =>
                        setData(selectedOption.value, "academic_year")
                      }
                      options={FinancialYearOptions()}
                    />
                  </div>
                  <div className="col-lg-4">
                    <button className="requestbtn" onClick={getReport}>Get Report</button>
                  </div>
                </div>
                <table className="table table-hover mt-5">
                  <thead>
                    <tr>
                      <th scope="col">Employee Name</th>
                      <th scope="col">Department</th>
                      <th scope="col">Year</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {savedReport?.length > 0 ? (
                      savedReport &&
                      savedReport?.map((saved, index) => (
                        <tr key={index}>
                          <td>{saved?.name ? saved?.name : "-"}</td>
                          <td>{saved?.department ? saved?.department : "-"}</td>
                          <td>{saved?.academic_year ? saved?.academic_year + '-' + (saved?.academic_year + 1) : "-"}</td>
                          <td>
                            {saved?.document_url !== ' ' ?
                              <a href={`${imagepath + saved?.document_url}`} download='PropertyReturnsDocument' target="_blank">
                                <span class="material-symbols-outlined" >
                                  download_2
                                </span>
                              </a>
                              : "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <>
                        <tr>
                          <td colSpan={2}>
                            <div> No Data Found</div>
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AdminPropertyReport;
